module.exports = __webpack_public_path__ + "static/bg-tools-73675d7557525066172e5e5aa72aadc0.jpg";